import "./index.scss";
import { CartTerms } from "..";
import { selectTooltip } from "./utils/tooltip";
import { IconButton } from "components/UI/atoms";
import { ReactComponent as PlusIcon } from "assets/add.svg";
import { ReactComponent as MinusIcon } from "assets/remove.svg";
import { useState } from "react";
import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import { useCartContext } from "context/cart-context";

export const CartItem = ({
  brandUuid,
  listingUuid,
  userUuid,
  timeIsUp,
  isUnifiedCart,
  name,
  imageSrc,
  value,
  discount,
  price,
  deliveryType,
  terms,
  cardType
}) => {
  const [termsExpanded, setTermsExpanded] = useState(false);
  const { removeCard } = useCartContext();

  const handleExpandTerms = () => setTermsExpanded(!termsExpanded);
  const handleRemoveButtonClick = async () => {
    const payload = {
      brandUUID: brandUuid,
      listingUUID: listingUuid,
      userID: userUuid
    };

    await removeCard(payload);
  };

  return (
    <div
      className={`cart-item ${termsExpanded && "expanded"} ${
        timeIsUp && "expired"
      }`}
    >
      <div className="cart-item-logo">
        <img className="desktop-logo" src={imageSrc} alt="logo" />
      </div>
      <div className="cart-item-rows">
        <div className="header">
          <img className="mobile-logo" src={imageSrc} alt="logo" />
          <div className="header-text">
            <p>{name} Gift Card</p>
            {deliveryType && (
              <p className="delivery">{selectTooltip(deliveryType)}</p>
            )}
          </div>
          <IconButton
            IconComponent={MinusIcon}
            onClick={() => void handleRemoveButtonClick()}
            disabled={timeIsUp}
            className="remove-item-button"
            aria-label="remove"
            alt="delete cart item"
          />
          <button
            onClick={() => handleRemoveButtonClick()}
            disabled={timeIsUp}
            className="remove-item-text"
          >
            Remove
          </button>
        </div>
        <hr className="divider" />
        <div className="details">
          <p>Card Value</p>
          <p>{value}</p>
        </div>
        {isUnifiedCart && (
          <div className="details">
            <p>Discount</p>
            <p>{discount} Off</p>
          </div>
        )}
        <div className="details price">
          <p>Your Price</p>
          <p>{toMoneyWithTwoDecimalDigits(price)}</p>
        </div>
        <button
          onClick={handleExpandTerms}
          disabled={timeIsUp}
          className={`expand-terms ${termsExpanded && "expanded"}`}
          aria-label="view redemption"
          alt="view redemption"
        >
          {termsExpanded ? <MinusIcon /> : <PlusIcon />}
          <p>View Redemption Details and Gift Card Terms</p>
        </button>
        {termsExpanded && (
          <CartTerms name={name} terms={terms} cardType={cardType} />
        )}
      </div>
    </div>
  );
};
